import React, { useState } from 'react'
// import antd from "antd"
import 'antd/dist/antd.css';
import { Answer } from "./Ans"
import Datas from "./QuestionList"
import { Steps, Button, message } from 'antd';
import { useDispatch } from 'react-redux';

import {totalScore} from "../../../redux/action-creator"

const { Step } = Steps;

// const steps = [
//     {
//       title: 'First',
//       content: 'First-content',
//     },
//     {
//       title: 'Second',
//       content: 'Second-content',
//     },
//     {
//       title: 'Last',
//       content: 'Last-content',
//     },
//   ];

// const steps = [
//     {
//       title: 'First',
//       content: 'First-content',
//     },
//     {
//       title: 'Second',
//       content: 'Second-content',
//     },
//     {
//       title: 'Last',
//       content: 'Last-content',
//     },
//   ];
function ReactQues() {
  const  dispatch=useDispatch()
    // const [current, setCurrent] = React.useState(0);
    const [current, setCurrent] = React.useState(0);

    const [score, setScor] = useState(0)
    // const [checkEd,setChecked]=useState(false)
    const [stopQuestionRepeat, setStopQuestionRepeat] = useState([])
    let arr = []

    // const seeScor = () => {
    //     console.log("++ scor +++=", score)
    // }
    const checkboxHandle = (event) => {
        // console.log("++++++ steps.lngth ++++", current)

        // console.log(event.target.checked,"ppp")
        // console.log(event.target.name,"+++  name +++++++++")
        const filterId = Datas.filter(ques => ques.id === event.target.id)
        // if(event.target.checked){
        //     setChecked(true)
        // }else{
        //     setChecked(false)
        // }
        if (event.target.checked === true && event.target.name === "ans") {
            console.log("++++ filterId +++=", filterId)
          
            
            console.log("+++++ arr ++++", arr)
            // if(stopQuestionRepeat.includes(filterId[0].id) == true){
            //     const index=stopQuestionRepeat.indexOf(filterId[0].id)
            //     if(index >-1){
            //         stopQuestionRepeat.splice(index,1)
            //     }
            // }
            if (stopQuestionRepeat.includes(filterId[0].id) !== true) {
                console.log("+++++ hello +++++", arr)
                stopQuestionRepeat.push(filterId[0].id)
                // arr.push(filterId[0].id)

                console.log("test", stopQuestionRepeat);
                console.log("test", setStopQuestionRepeat)
                console.log("test", contentReactQues)

                // setScor(score + 1)
                dispatch(totalScore(setScor(score + 1)))

            }

        }


    }

    let steps = []
    const contentReactQues = Datas.forEach((data, key) => {
        steps.push({
            content: <div style={{ padding: "20px" }} key={key}>
                <h1>
                    {key + 1}. {data.ques}
                </h1>
                <p   style={{ marginTop: "7px", fontSize: '18px',color:"black" }} ><input type="checkbox"  
                // checked={test ? true:false}
                 id={Answer[key][0]} name={Answer[key][1]}
                    onChange={checkboxHandle} />{data.a}</p>
                <p   onChange={checkboxHandle} style={{ marginTop: "7px", fontSize: '18px',color:"black" }}><input  type="checkbox" id={Answer[key][0]} name={Answer[key][2]} />{data.b}</p>
                <p   onChange={checkboxHandle} style={{ marginTop: "7px", fontSize: '18px',color:"black" }}><input  type="checkbox" id={Answer[key][0]} name={Answer[key][3]} />{data.d}</p>
                <p   onChange={checkboxHandle} style={{ marginTop: "7px", fontSize: '18px',color:"black" }}><input  type="checkbox" id={Answer[key][0]} name={Answer[key][4]} />{data.c}</p>


            </div>,
            // title:`${key + 1}`
        })
    })
    const next = () => {
        setCurrent(current + 1);
    };

    const prev = () => {
        setCurrent(current - 1);
    };

    const submitReactQuesHandle = () => {
        if (current === 3) {
            alert(score)
        }
        message.success('Processing complete!')
    }
    // const questonList= Datas.map((data,key)=>{
    //     return(
    //     <div style={{padding:"20px"}}>
    //       <h1>
    //         {key+1}. {data.ques}
    //       </h1>
    //       <p style={{marginTop:"7px",fontSize:'18px'}}><input type="checkbox" />{data.a}</p>
    //       <p style={{marginTop:"7px"}}><input type="checkbox" />{data.b}</p>
    //       <p style={{marginTop:"7px"}}><input type="checkbox" />{data.d}</p>
    //       <p style={{marginTop:"7px"}}><input type="checkbox" />{data.c}</p>


    //     </div>
    //     )
    // })
    return (
        <>
            <Steps current={current}>
                {steps.map(item => (
                    <Step key={item.title} title={item.title} />
                ))}
            </Steps>
            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>

                <div className="steps-content">{steps[current].content}</div>
                <div className="steps-action" style={{ display: "flex" }}>


                    {current === 0 && (
                        <Button disabled style={{ margin: '0 8px' }} onClick={() => prev()}>
                            Previous
                        </Button>
                    )}
                    {current > 0 && (
                        <Button style={{ margin: '0 8px' }} onClick={() => prev()}>
                            Previous
                        </Button>
                    )}
                    {current < steps.length - 1 && (
                        <Button type="primary" onClick={() => next()}>
                            Next
                        </Button>
                    )}
                    {current === steps.length - 1 && (
                        //   <Button type="primary" onClick={() => message.success('Processing complete!')}>
                        // <Button type="primary" onClick={submitReactQuesHandle}>

                        //     Submit ReactQues
                        // </Button>
                        <Button disabled type="primary" onClick={submitReactQuesHandle}>

                            Next
                        </Button>
                    )}
                </div>
            </div>
        </>
        // <div style={{fontFamily:"sans-serif"}}>
        //     <div style={{margin:"50px"}}>
        //     {questonList}

        //     </div>
        //     {/* <div style={{display:"flex",justifyContent:'space-between',marginTop:'50px'}}>
        //         <div style={{marginLeft:"50px",paddingBottom:"15px"}}>
        //             <button style={{backgroundColor:"crimson",padding:'8px 25px',outline:"none",
        //         border:"none",color:"white",borderRadius:"5px"}}>Prev</button>
        //         </div>
        //         <div style={{marginRight:"50px"}}>
        //             <button style={{backgroundColor:"crimson",padding:'8px 25px',outline:"none",
        //         border:"none",color:"white",borderRadius:"5px"}}>next</button>
        //         </div>
        //     </div> */}
        // </div>
    )
}

export default ReactQues
